import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';

function GestionCookies() {
    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState<DialogProps['scroll']>('paper');

    const handleClickOpen = (scrollType: DialogProps['scroll']) => () => {
        setOpen(true);
        setScroll(scrollType);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const descriptionElementRef = React.useRef<HTMLElement>(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    const {t} = useTranslation() as {t:(key:string)=>string}
  return (
     <div>
        <button onClick={handleClickOpen('paper')}>{t("Gestion des cookies")}</button>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description">

              <DialogTitle id="scroll-dialog-title" className='text-xl font-semibold text-orange-500' >{t("Gestion des cookies")}</DialogTitle>
                <DialogContent dividers={scroll === 'paper'}>
                                                
                    <DialogContentText
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                        tabIndex={-1}>
                         
                          <div className="w-full h-full">

                                <div className="text-gray-700 mt-4">
                                    <h3 className="text-lg font-semibold">Qu’est-ce qu’un cookie ?</h3>
                                   <p className="text-justify">
                                        Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, smartphone, tablette) lors de la consultation d’un site internet. 
                                        Il permet de collecter des informations relatives à votre navigation et de vous adresser des services adaptés à vos centres d’intérêt.
                                        Les cookies ne contiennent pas d’informations personnelles et ne peuvent pas exécuter de programme ou transmettre de virus.
                                   </p>
                                </div>

                               <div className="text-gray-700 mt-4">
                                    <h3 className="text-lg font-semibold">Quels types de cookies utilisons-nous ?</h3>
                                    <p className="text-justify">
                                        Nous utilisons différents types de cookies pour améliorer votre expérience sur notre site et pour des finalités spécifiques :
                                    </p>
                                    <ul className="list-disc pl-5 mt-2 w-full">
                                    <li className="w-full">Cookies strictement nécessaires : indispensables au bon
                                             fonctionnement du site, ils permettent de naviguer et d’utiliser les fonctionnalités de base.
                                    </li>
                                    <li className="w-full">Cookies de performance : recueillent des informations anonymes sur 
                                         l’utilisation du site (ex. : pages les plus visitées, erreurs éventuelles) pour améliorer son fonctionnement.
                                    </li>
                                    <li className="w-full">Cookies de fonctionnalité : permettent de mémoriser vos 
                                               préférences (langue, région, identifiants de connexion, etc.).
                                    </li>
                                    <li className="w-full">Cookies de ciblage ou publicitaires : utilisés pour vous proposer
                                               des publicités personnalisées en fonction de vos centres d’intérêt.
                                    </li>
                                    </ul>
                                </div>

                                <p className="text-justify text-gray-700 mt-4">
                                    {t("En acceptant cette politique, vous consentez à la collecte et à l'utilisation de vos informations conformément à nos pratiques décrites.")}
                                </p>
                        </div>

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button className='transform active:scale-75 transition-transform' style={{backgroundColor:"#233D4D", color:"white"}} onClick={handleClose}>{t("Retour")}</Button>
                    <Button className='transform active:scale-75 transition-transform' style={{border:"2px solid #233D4D", color:"#233D4D"}} onClick={handleClose}>{t("Accepter")}</Button>
                </DialogActions>
            </Dialog>
    </div>
  )
}

export default GestionCookies